
export enum DbNamesEnum {
    IHS = "IHS",
    IHS_HISTORY = "IHS_HISTORY",
    IHS_OPEN = "IHS_OPEN",
    IHS_SHARED = "IHS_SHARED"
}
